import * as React from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import muradiLogo from "../../assets/Images/muradizBanner.png";
import TopLocaleBar from "../common/TopLocaleBar";

function Copyright(props: any) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {"Copyright © "}
      <Link color="inherit" href="https://muradiz.com/">
        Muradiz
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

interface AuthCardLayoutProps {
  title: string;
  children: React.ReactNode;
}

const AuthCardLayout: React.FC<AuthCardLayoutProps> = ({ title, children }) => {
  return (
    <Box sx={{ minHeight: "100vh", background: "linear-gradient(135deg,#F4F6FA 0%,#EEF0FB 100%)" }}>
      <Box sx={{ maxWidth: "1200px", minHeight: "100vh", marginInline: "auto", px: 2 }}>
        <Grid container component="main" sx={{ minHeight: "100vh", alignItems: "center" }}>
          <CssBaseline />
          <Grid
            item
            xs={false}
            sm={4}
            md={7}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <Box
              component="img"
              src={muradiLogo}
              alt="Muradiz — Manage smart. Grow faster."
              sx={{ width: "90%", maxWidth: "560px", height: "auto", objectFit: "contain" }}
            />
          </Grid>
          <Grid item xs={12} sm={8} md={5}>
            <Box
              sx={{
                my: 4,
                p: { xs: 3, sm: 5 },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                bgcolor: "background.paper",
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 4,
                boxShadow: "0 20px 50px rgba(15,23,42,0.08)",
              }}
            >
              <TopLocaleBar />
              <Typography component="h1" variant="h5" sx={{ mt: 1, fontWeight: 700 }}>
                {title}
              </Typography>
              <Box sx={{ mt: 1, width: "100%" }}>{children}</Box>
              <Copyright sx={{ mt: 5 }} />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default AuthCardLayout;
